import SETUP_WIZARDS_STEPS, { SETUP_WIZARDS } from '@/constants/setup-wizards'
import store from '@/store'
import { BUSINESS_FEATURES } from '@/constants/business-types'
import { PACKAGE_PERMISSIONS } from '@/constants/features'
import SUBUSER_PERMISSION_SLUGS from '@/constants/authorization/subuser-permission-slugs'

export default [
  {
    title: 'navigation.marketing',
    svgIcon: 'icon-marketing',
    permission: [
      SUBUSER_PERMISSION_SLUGS.MARKETING_ACCESS,
      SUBUSER_PERMISSION_SLUGS.PROMOTIONS_VIEW,
      SUBUSER_PERMISSION_SLUGS.SURVEYS_VIEW,
      SUBUSER_PERMISSION_SLUGS.NOTIFICATIONS_VIEW,
      SUBUSER_PERMISSION_SLUGS.BANNERS_VIEW,
      SUBUSER_PERMISSION_SLUGS.COUPONS_VIEW,
      SUBUSER_PERMISSION_SLUGS.DISCOUNTS_VIEW,
      SUBUSER_PERMISSION_SLUGS.NEWSLETTERS_VIEW,
      SUBUSER_PERMISSION_SLUGS.CAMPAIGNS_VIEW,
    ],
    children: [
      {
        title: 'mobile.campaign.page-title',
        route: 'admin:mobile:notifications',
        svgIcon: 'icon-mobile-notifications',
        permission: SUBUSER_PERMISSION_SLUGS.NOTIFICATIONS_VIEW,
        hide: () => !store.getters['subscription/isMobileAppPurchased'],
      },
      {
        title: 'whatsapp.title',
        route: 'admin:wp-campaigns',
        svgIcon: 'WhatsappIcon',
        permission: SUBUSER_PERMISSION_SLUGS.CAMPAIGNS_VIEW,
        hide: () => !store.getters['subscription/isWhatsappMarketingPurchased'],
      },
      {
        title: 'navigation.surveys',
        route: 'admin:surveys',
        tag: 'upgrade',
        tagPackagePermission: PACKAGE_PERMISSIONS.FEEDBACK,
        wizard: SETUP_WIZARDS.SURVEY,
        svgIcon: 'icon-customers-surveys',
        stepsNames: SETUP_WIZARDS_STEPS[SETUP_WIZARDS.SURVEY]?.stepsNames ?? [],
        permission: SUBUSER_PERMISSION_SLUGS.SURVEYS_VIEW,
      },
      {
        title: 'navigation.marketing-events',
        route: 'admin:marketing-events',
        tag: 'upgrade',
        tagPackagePermission: PACKAGE_PERMISSIONS.MARKETING_EVENT,
        wizard: SETUP_WIZARDS.MARKETING_EVENTS,
        svgIcon: 'icon-coupons',
        stepsNames: SETUP_WIZARDS_STEPS[SETUP_WIZARDS.MARKETING_EVENTS]?.stepsNames ?? [],
        permission: SUBUSER_PERMISSION_SLUGS.MARKETING_EVENTS_VIEW,
        hide: () => !store.getters['businessTypes/isEnabled'](BUSINESS_FEATURES.COUPONS),
      },
      {
        title: 'navigation.coupons',
        route: 'admin:coupons',
        tag: 'upgrade',
        tagPackagePermission: PACKAGE_PERMISSIONS.COUPON,
        wizard: SETUP_WIZARDS.COUPONS,
        svgIcon: 'icon-coupons',
        stepsNames: SETUP_WIZARDS_STEPS[SETUP_WIZARDS.COUPONS]?.stepsNames ?? [],
        permission: SUBUSER_PERMISSION_SLUGS.COUPONS_VIEW,
        hide: () => !store.getters['businessTypes/isEnabled'](BUSINESS_FEATURES.COUPONS),
      },
      {
        title: 'navigation.discounts',
        route: 'admin:discounts',
        tag: 'upgrade',
        tagPackagePermission: PACKAGE_PERMISSIONS.DISCOUNT,
        wizard: SETUP_WIZARDS.DISCOUNTS,
        svgIcon: 'icon-discounts',
        stepsNames: SETUP_WIZARDS_STEPS[SETUP_WIZARDS.DISCOUNTS]?.stepsNames ?? [],
        permission: SUBUSER_PERMISSION_SLUGS.DISCOUNTS_VIEW,
        hide: () => !store.getters['businessTypes/isEnabled'](BUSINESS_FEATURES.DISCOUNTS),
      },
      {
        title: 'navigation.newsletter',
        route: 'admin:newsletters',
        wizard: SETUP_WIZARDS.NEWSLETTER,
        tag: 'upgrade',
        tagPackagePermission: PACKAGE_PERMISSIONS.NEWSLETTER,
        svgIcon: 'icon-newsletter',
        permission: SUBUSER_PERMISSION_SLUGS.NEWSLETTERS_VIEW,
        hide: () => store.getters['setup/hideNewsletterWizard'],
        stepsNames: SETUP_WIZARDS_STEPS[SETUP_WIZARDS.NEWSLETTER]?.stepsNames ?? [],
      },
      {
        title: 'navigation.banners-pop-ups',
        svgIcon: 'icon-banners',
        route: 'admin:banners',
        permission: SUBUSER_PERMISSION_SLUGS.BANNERS_VIEW,
      },
      // {
      //   title: 'navigation.campaigns',
      //   svgIcon: 'marketing-campaign',
      //   route: 'admin:campaigns',
      // },
      {
        title: 'navigation.wallet-packages',
        route: 'admin:wallet-packages',
        tag: 'upgrade',
        tagPackagePermission: PACKAGE_PERMISSIONS.WALLET_PACKAGES,
        svgIcon: 'icon-wallet-packages',
        permission: SUBUSER_PERMISSION_SLUGS.WALLETS_MANAGE,
        hide: () => !store.getters['businessTypes/isEnabled'](BUSINESS_FEATURES.WALLET_PACKAGES) || (!store.getters['auth/user'].enable_wallet),
      },
      {
        title: 'navigation.promotions',
        route: 'admin:promotions',
        tag: 'upgrade',
        tagPackagePermission: PACKAGE_PERMISSIONS.PROMOTIONS,
        wizard: SETUP_WIZARDS.PROMOTIONS,
        svgIcon: 'PromotionIcon',
        stepsNames: SETUP_WIZARDS_STEPS[SETUP_WIZARDS.PROMOTIONS]?.stepsNames ?? [],
        permission: SUBUSER_PERMISSION_SLUGS.PROMOTIONS_VIEW,
        hide: () => !store.getters['businessTypes/isEnabled'](BUSINESS_FEATURES.PROMOTIONS) || (!store.getters['auth/user'].enable_promotions),
      },
    ],
  },
]
